// This script runs synchronously before React renders
// It loads the cached font immediately to prevent flash of wrong font

const FONT_CACHE_KEY = 'org-font';
const FONT_SIZE_CACHE_KEY = 'org-font-size';

// Try to get cached font
const cachedFont = localStorage.getItem(FONT_CACHE_KEY);
const cachedFontSize = localStorage.getItem(FONT_SIZE_CACHE_KEY);

if (cachedFont) {
    // Set CSS variable immediately
    document.documentElement.style.setProperty('--font-sans', `'${cachedFont}', sans-serif`);
    
    // Load Google Font if needed
    const GOOGLE_FONTS = [
        'Inter', 'Roboto', 'Open Sans', 'Lato', 'Montserrat',
        'Poppins', 'Nunito', 'PT Sans', 'Raleway'
    ];
    
    if (GOOGLE_FONTS.includes(cachedFont)) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = `https://fonts.googleapis.com/css2?family=${cachedFont.replace(/\s/g, '+')}:wght@300;400;500;600;700&display=swap`;
        document.head.appendChild(link);
    }
}

if (cachedFontSize) {
    // Set font size on html element
    document.documentElement.style.fontSize = cachedFontSize;
}

export { FONT_CACHE_KEY, FONT_SIZE_CACHE_KEY };
